;(function(win) {
  // layout + section 可能各引一次 utils.js，整页只初始化一次
  if (win.CommunityUtils) return;

  var STORAGE_KEY = 'community_api_region';
  var LOGIN_COUNTRY_KEY = 'login_country_code';
  var LANG_STORAGE_KEY = 'community_lang';

  var API_BY_REGION = {
    '0': 'https://us-api-jiyin.hannto.com',  // 北美
    '1': 'https://de-api-jiyin.hannto.com',  // 欧洲
    '2': 'https://sg-api-jiyin.hannto.com',  // 亚太
    '3': 'https://api-jiyin.hannto.com'      // 中国
  };

  // 与 login 国家 → 机房映射一致；仅在用户明确选过国家时使用
  var REGION_BY_COUNTRY = {
    BR: '0', CA: '0', CL: '0', CO: '0', MX: '0', OT: '0', PE: '0', PR: '0', US: '0',
    AE: '1', AT: '1', BE: '1', CH: '1', CZ: '1', DE: '1', DK: '1', ES: '1', FI: '1',
    FR: '1', GB: '1', IE: '1', IT: '1', KW: '1', LU: '1', MC: '1', MT: '1', NL: '1',
    NO: '1', PL: '1', SA: '1', SE: '1',
    AU: '2', ID: '2', IN: '2', JP: '2', KR: '2', MY: '2', PH: '2', SG: '2', TH: '2', TW: '2',
    CN: '3'
  };

  function writeStoredRegion(code) {
    if (!API_BY_REGION[code]) return;
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}
  }

  function readLoginSelectedRegion() {
    try {
      var country = String(localStorage.getItem(LOGIN_COUNTRY_KEY) || '').toUpperCase();
      if (!country || !REGION_BY_COUNTRY[country]) return '';
      var region = REGION_BY_COUNTRY[country];
      return API_BY_REGION[region] ? region : '';
    } catch (e) {
      return '';
    }
  }

  function regionFromCountryCode(code) {
    var country = String(code || '').toUpperCase() || 'US';
    var region = REGION_BY_COUNTRY[country] || '0';
    return API_BY_REGION[region] ? region : '0';
  }

  function applyRegion(code, opts) {
    opts = opts || {};
    var persist = !!opts.persist;
    // locked=true 表示使用的是显式 serviceCode（来自URL或之前存入的 localStorage）
    var locked = opts.locked === undefined ? persist : !!opts.locked;
    if (!API_BY_REGION[code]) code = '0';
    if (persist) writeStoredRegion(code);
    win.__communityApiRegion = code;
    win.__communityApiRegionLocked = locked;
  }

  function normalizeLocaleCode(code, fallback) {
    var value = String(code || '').trim();
    var lower = value.toLowerCase().replace(/_/g, '-');
    var fb = String(fallback || '').trim().toLowerCase().replace(/_/g, '-');
    if (lower === 'zh-hans' || lower === 'zh-cn' || lower === 'zh-hans-cn') return 'zh-CN';
    if (lower === 'zh-hant' || lower === 'zh-tw' || lower === 'zh-hk' || lower === 'zh-hant-tw') return 'zh-TW';
    if (lower === 'zh') {
      if (fb === 'zh-tw' || fb === 'zh-hk' || fb === 'zh-hant' || fb === 'zh-hant-tw') return 'zh-TW';
      return 'zh-CN';
    }
    var base = lower.split('-')[0];
    if (base === 'en' || base === 'de' || base === 'es' || base === 'fr' || base === 'it' || base === 'ja' || base === 'ko' || base === 'ru') return base;
    return '';
  }

  function getUrlLanguageValue() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('language') || '';
    } catch (e) {
      return '';
    }
  }

  function getStoredLocaleCode() {
    try {
      return localStorage.getItem(LANG_STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function writeStoredLocaleCode(code) {
    var normalized = normalizeLocaleCode(code);
    if (!normalized) return '';
    try {
      localStorage.setItem(LANG_STORAGE_KEY, normalized);
    } catch (e) {}
    return normalized;
  }

  function getBrowserLocaleCode() {
    var lang = navigator.language || navigator.userLanguage || '';
    return normalizeLocaleCode(lang);
  }

  function getProjectLocaleCode() {
    return normalizeLocaleCode(getStoredLocaleCode()) || '';
  }

  function ensureInitialLocaleCode() {
    var locale = getProjectLocaleCode();
    if (locale) return locale;

    locale =
      getBrowserLocaleCode() ||
      normalizeLocaleCode(document.documentElement && document.documentElement.lang) ||
      'en';

    return writeStoredLocaleCode(locale) || locale;
  }

  function localeCodeToLanguageParam(code) {
    var locale = normalizeLocaleCode(code);
    if (locale === 'zh-CN') return 'zh-hans';
    if (locale === 'zh-TW') return 'zh-hant';
    return locale || 'en';
  }

  function getLanguageValue() {
    return localeCodeToLanguageParam(ensureInitialLocaleCode());
  }

  function resolveApiBaseUrl() {
    var lockedCode = win.__communityApiRegionLocked ? win.__communityApiRegion : '';
    if (lockedCode && API_BY_REGION[lockedCode]) return API_BY_REGION[lockedCode];
    return API_BY_REGION['0'];
  }

  function resolveApiBaseUrlByServiceCode(serviceCode) {
    var code = getUrlServiceCode();
    if (!code && serviceCode != null && serviceCode !== '') {
      code = String(serviceCode);
      if (!API_BY_REGION[code]) code = '';
    }
    if (API_BY_REGION[code]) {
      applyRegion(code, { persist: true, locked: true });
      return API_BY_REGION[code];
    }
    return resolveApiBaseUrl();
  }

  function getUrlServiceCode() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var code = params.get('serviceCode');
      code = String(code == null ? '' : code);
      return API_BY_REGION[code] ? code : '';
    } catch (e) {
      return '';
    }
  }

  function formatCompactCount(raw) {
    var n = Math.floor(Number(raw))
    if (!Number.isFinite(n) || n < 0) return '0'
    if (n < 10000) return String(n)
    var suffix = '+'
    return '9999' + suffix;
  }

  function asRecord(v) {
    return v && typeof v === 'object' ? v : {};
  }

  function pickCommunityCover(source, detail) {
    var img = asRecord(source.cover_image_info);
    var imgD = asRecord(detail.cover_image_info);
    return String(
      img.thumbnail || imgD.thumbnail || img.image_url || imgD.image_url ||
      source.cover || source.url || detail.cover || detail.url || ''
    );
  }

  function normalizeCommunityItem(raw) {
    var source = asRecord(raw);
    var detail = asRecord(source.detail);
    return {
      id: source.id || detail.id || '',
      name: String(source.name || detail.name || ''),
      cover: pickCommunityCover(source, detail),
      url: String(source.url || detail.url || ''),
      avatar: String(source.avatar || detail.avatar || ''),
      nick_name: String(source.nick_name || detail.nick_name || ''),
      type: Number(source.type || detail.type || 0),
      collect_count: Number(source.collect_count || detail.collect_count || 0)
    };
  }

  var coverObserver = null;

  function getCoverObserver() {
    if (coverObserver) return coverObserver;
    if (!('IntersectionObserver' in window)) return null;
    coverObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var url = el.getAttribute('data-community-cover');
        if (url && !el.getAttribute('src')) el.src = url;
        coverObserver.unobserve(el);
      });
    }, { rootMargin: '200px 0px', threshold: 0 });
    return coverObserver;
  }

  function bindCommunityCovers(root) {
    if (!root) return;
    var imgs = root.querySelectorAll('img[data-community-cover]');
    var observer = getCoverObserver();
    for (var i = 0; i < imgs.length; i++) {
      var el = imgs[i];
      if (el.getAttribute('src')) continue;
      if (!el.getAttribute('loading')) el.setAttribute('loading', 'lazy');
      var url = el.getAttribute('data-community-cover');
      if (!url) continue;
      if (observer) observer.observe(el);
      else el.src = url;
    }
  }

  function isTouchPrimaryDevice() {
    try {
      return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    } catch (e) {
      return false;
    }
  }

  function isDesktopMacOrWindows() {
    var ua = navigator.userAgent || '';
    var uaLower = ua.toLowerCase();
    if (/windows phone|iemobile/i.test(uaLower)) return false;
    if (/windows/i.test(ua)) return true;
    if (/macintosh|mac os x/i.test(ua) && navigator.maxTouchPoints <= 1) return true;
    return false;
  }

  function isMobileDevice() {
    var ua = navigator.userAgent || '';
    var uaLower = ua.toLowerCase();

    if (/iPhone|iPod|iPad/i.test(ua)) return true;
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    if (/android/i.test(ua)) return true;
    if (/harmonyos|harmony/i.test(uaLower)) return true;
    if (/windows phone|iemobile|blackberry|opera mini|webos/i.test(uaLower)) return true;
    if (!isDesktopMacOrWindows() && /miuibrowser|huaweibrowser|heytapbrowser|vivobrowser|samsungbrowser|ucbrowser|ucweb|quark|mqqbrowser|qqbrowser|baidubrowser|liebaofast|sogoumobile/i.test(uaLower)) return true;
    if (isTouchPrimaryDevice()) return true;

    var uaData = navigator.userAgentData;
    if (uaData && uaData.mobile === true) return true;

    return false;
  }

  function isPcDevice() {
    return !isMobileDevice();
  }

  function getPadType() {
    var ua = (navigator.userAgent || '').toLowerCase();
    var platform = (navigator.platform || '').toLowerCase();
    var w = window.innerWidth || document.documentElement.clientWidth || 0;

    if (ua.indexOf('ipad') !== -1 || (platform.indexOf('mac') !== -1 && navigator.maxTouchPoints > 1)) {
      return 'ios';
    }
    if (w >= 743) {
      return 'android';
    }
    return false;
  }

  var Utils = {
    getLanguage: function() {
      return getLanguageValue();
    },
    getLocaleCode: function() {
      // 不写入 localStorage，避免覆盖 UI 默认语言逻辑。
      return getProjectLocaleCode() || getBrowserLocaleCode() || 'en';
    },
    toLanguageHeader: function(lang) {
      if (lang === 'zh-hans') return 'zh';
      if (lang === 'zh-hant') return 'zh-Hant';
      return lang || 'en';
    },
    getApiBaseUrl: function(mode, serviceCode) {
      if (mode === 'serviceCode') return resolveApiBaseUrlByServiceCode(serviceCode);
      return resolveApiBaseUrl();
    },
    getServiceCode: function() {
      var urlCode = getUrlServiceCode();
      if (urlCode) return urlCode;
      if (win.__communityApiRegionLocked && win.__communityApiRegion) return win.__communityApiRegion;
      return '0';
    },
    appendServiceCodeToSearchParams: function(sp) {
      if (!sp || typeof sp.set !== 'function') return;
      var sc = this.getServiceCode();
      if (sc != null && sc !== '') sp.set('serviceCode', String(sc));
    },
    escapeHTML: function(text) {
      var div = document.createElement('div');
      div.textContent = text == null ? '' : String(text);
      return div.innerHTML;
    },
    formatCompactCount: formatCompactCount,
    normalizeCommunityItem: normalizeCommunityItem,
    bindCommunityCovers: bindCommunityCovers,
    isMobileDevice: isMobileDevice,
    isPcDevice: isPcDevice,
    getPadType: getPadType
  };

  // 优先级：URL serviceCode（外链等）> login 明确选国家 > 每页按 IP 检测
  var regionReadyResolve;
  var regionReady = new Promise(function(resolve) { regionReadyResolve = resolve; });
  Utils.whenApiRegionReady = function() { return regionReady; };

  var urlCode = getUrlServiceCode();
  if (urlCode) {
    applyRegion(urlCode, { persist: true, locked: true });
    regionReadyResolve(urlCode);
  } else {
    var loginRegion = readLoginSelectedRegion();
    if (loginRegion) {
      applyRegion(loginRegion, { persist: true, locked: true });
      regionReadyResolve(loginRegion);
    } else {
      // 同页多次引入 utils.js 由顶部守卫拦住，保证只请求一次
      applyRegion('0', { persist: false, locked: true });
      var root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
      fetch(root + 'browsing_context_suggestions.json?country[enabled]=true')
        .then(function(res) { return res.json().catch(function() { return {}; }); })
        .then(function(data) {
          var country = data && data.detected_values && data.detected_values.country;
          var handle = country && (country.handle || country.iso_code);
          var region = regionFromCountryCode(handle);
          applyRegion(region, { persist: false, locked: true });
          regionReadyResolve(region);
        })
        .catch(function() {
          applyRegion('0', { persist: false, locked: true });
          regionReadyResolve('0');
        });
    }
  }
  win.CommunityUtils = Utils;
})(window);